import { Link } from "react-router-dom";
import { slugifyProducerName } from "../services/producerService";

/* eslint-disable react/prop-types */
export default function ProducerBubble({ producer }) {
    const description = producer.description?.trim();
    const shortDescription =
        description && description.length > 95
            ? `${description.slice(0, 95)}...`
            : description;
    const sourceLabel =
        producer.source === "catpass" ? "CatPass" : "PassEvent";
    const profilePath =
        producer.source === "passevent" && producer.name
            ? `/producers/${slugifyProducerName(producer.name)}`
            : null;

    const card = (
        <article className="group overflow-hidden rounded-2xl border border-zinc-800 bg-zinc-900/70 shadow-[0_12px_34px_rgba(0,0,0,0.35)] transition-transform duration-300 hover:-translate-y-1 hover:border-zinc-700">
            <div className="relative aspect-[4/3] overflow-hidden">
                <img
                    src={producer.img}
                    alt={producer.name}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <h3 className="absolute bottom-3 left-3 right-3 text-lg font-semibold text-white drop-shadow">
                    {producer.name}
                </h3>
            </div>

            <div className="space-y-3 p-4">
                <p className="min-h-[2.5rem] text-sm text-zinc-300">
                    {shortDescription ||
                        `Productora activa en ${sourceLabel}.`}
                </p>
                {profilePath ? (
                    <span className="inline-flex rounded-full border border-zinc-700 bg-zinc-800/80 px-3 py-1 text-xs font-semibold uppercase tracking-[0.12em] text-zinc-200">
                        Ver perfil
                    </span>
                ) : null}
            </div>
        </article>
    );

    return profilePath ? (
        <Link to={profilePath} className="group block">
            {card}
        </Link>
    ) : (
        card
    );
}
